const target = document.getElementById('js-sticky-atc__target');
const sticky = document.getElementById('js-sticky-atc');

let lastScrollY = window.scrollY;
let isStickyVisible = false;

function onScroll() {
  const rect = target.getBoundingClientRect();
  const scrollingDown = window.scrollY > lastScrollY;
  lastScrollY = window.scrollY;
  if (scrollingDown && rect.bottom <= 0 && !isStickyVisible) {
    sticky.classList.add('is-visible');
    isStickyVisible = true;
    return;
  }

  if (!scrollingDown && rect.top >= 0 && isStickyVisible) {
    sticky.classList.remove('is-visible');
    isStickyVisible = false;
    return;
  }
}

document.addEventListener('scroll', onScroll, { passive: true });
